<template>
    <div></div>
</template>
<script>
/**
 * 此路由用于内网域登录且没有在域控下时
 * 登录会弹出账号密码框，当点击取消时，域登录服务器会回跳到此路由，来改变父窗口的登录loading状态
 */
export default {
  name: 'redirectPage',
  beforeRouteEnter (to, from, next) {
    window.parent.LOGIN.changeState()
  }
}

</script>
